const PRICING_REQUEST_TIME = 'PRICING_REQUEST_TIME';
const PRICING_REQUEST_PAUSED_TIME = 'PRICING_REQUEST_PAUSED_TIME';
const LONG_RUNNING_PRICING_REQUEST_TIME = 'LONG_RUNNING_PRICING_REQUEST_TIME';

export {
    PRICING_REQUEST_TIME,
    PRICING_REQUEST_PAUSED_TIME,
    LONG_RUNNING_PRICING_REQUEST_TIME
}